import React from 'react';

import CountryInfo from '../CountryInfo';

const PACKAGE_SECTION = {
    title: '£200m package support for small businesses',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    Retail, leisure and hospitality businesses with a rateable
                    value of £51,000 or less will receive 100% non-domestic
                    rates relief.
                </li>
                <li>
                    Pubs with a rateable value of between £51,000 and £100,000
                    will receive a £5,000 reduction on their bill.
                </li>
                <li>£100m for a new grant scheme for small businesses.</li>
                <li>
                    To contact:
                    <ul>
                        <li>
                            Call Business Wales Helpline: 0300 060 3000, Monday
                            to Friday, 8:30am to 5:30pm
                        </li>
                        <li>
                            Call HMRC Helpline: 0800 0159 559, Monday to Friday
                            8am to 8pm and Saturday 8am to 4pm
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Support for businesses in dealing with Covid-19',
            url: 'https://gov.wales/written-statement-support-businesses-dealing-covid-19',
        },
    ],
};

const BANK_SECTION = {
    title: 'Development Bank of Wales Response',
    content: <p>Three-month capital repayment holiday</p>,
    links: [
        {
            title: 'Businesses offered capital repayment holidays to help manage coronavirus impact',
            url: 'https://gov.wales/businesses-offered-capital-repayment-holidays-help-manage-coronavirus-impact',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Wales',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Wales has multiple different financial assistance options available.
            Please look over this information and follow up as appropriate.
        </p>
    ),
    sections: [PACKAGE_SECTION, BANK_SECTION],
};

const WalesInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default WalesInfo;
